module.exports = __webpack_public_path__ + "media/src/images/user/default_avatars/default_avatar_15-96d8ad1cbb9404ba1e27991b0e219a48.png";